import { IconType } from '@/ui-kit/components/icon/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { ListingGalleryActionTitle } from '../enums';
import BaseRedirectAction from '@/components/listing-card/helpers/base-redirect.action';

export default class SeeVideoAction extends BaseRedirectAction {
  title = ListingGalleryActionTitle.SeeVideo;
  icon = IconType.Camera;
  colorSchema = StyleColorSchemeType.Gray;

  // eslint-disable-next-line class-methods-use-this
  getLink({ videoTour }) {
    return videoTour.match(/http/) ? videoTour : `https://${videoTour}`;
  }
}
